module.exports = __webpack_public_path__ + "img/7.351b1817.png";